import axiosInstance from "../utils/axios";


/*
 * LẤY THÔNG TIN USER TỪ LOCALSTORAGE
 */
export const getHealthUser = () => {
    try {
        const userString =
            localStorage.getItem("user");

        if (!userString) {
            return null;
        }

        const user = JSON.parse(userString);

        if (!user || typeof user !== "object") {
            return null;
        }

        return user;

    } catch (error) {
        console.error(
            "Không thể đọc thông tin tài khoản:",
            error
        );

        return null;
    }
};


/*
 * LẤY TOKEN
 */
export const getHealthToken = () => {
    const user = getHealthUser();

    if (!user?.token) {
        return null;
    }

    let token = String(user.token).trim();

    /*
     * Nếu token đã có chữ Bearer thì bỏ đi,
     * phía dưới sẽ tự thêm Bearer lại.
     */
    if (
        token
            .toLowerCase()
            .startsWith("bearer ")
    ) {
        token = token.slice(7).trim();
    }

    return token || null;
};


/*
 * KIỂM TRA CÓ THỂ ĐỒNG BỘ THEO TÀI KHOẢN KHÔNG
 */
export const canSyncHealthData = () => {
    return Boolean(getHealthToken());
};


/*
 * TẠO HEADER TOKEN
 */
const getAuthConfig = () => {
    const token = getHealthToken();

    if (!token) {
        return null;
    }

    return {
        headers: {
            Authorization: `Bearer ${token}`,

            /*
             * Hạn chế trình duyệt/proxy dùng lại
             * dữ liệu GET cũ.
             */
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        }
    };
};


/*
 * CHỜ NGẮN RỒI THỬ LẤY TOKEN LẠI
 *
 * Hữu ích ngay sau khi vừa đăng nhập,
 * khi giao diện chuyển trang rất nhanh.
 */
const waitForHealthToken = async () => {
    let token = getHealthToken();

    if (token) {
        return token;
    }

    /*
     * Thử lại tối đa khoảng 1 giây.
     */
    for (let i = 0; i < 5; i++) {
        await new Promise((resolve) =>
            setTimeout(resolve, 200)
        );

        token = getHealthToken();

        if (token) {
            return token;
        }
    }

    return null;
};


/*
 * THỰC HIỆN GET LỊCH SỬ
 */
const requestHealthHistory = async (
    trackingType
) => {
    const config = getAuthConfig();

    if (!config) {
        return null;
    }

    /*
     * Thêm _t để URL mỗi lần khác nhau.
     * Điều này giúp tránh lấy lại response GET cũ.
     */
    const response =
        await axiosInstance.get(
            `/health-tracking/getByType/${trackingType}`,
            {
                ...config,

                params: {
                    _t: Date.now()
                }
            }
        );

    return response;
};


/*
 * LẤY LỊCH SỬ THEO LOẠI
 */
export const getHealthHistory = async (
    trackingType
) => {
    try {
        /*
         * Đảm bảo token đã tồn tại.
         */
        const token =
            await waitForHealthToken();

        if (!token) {
            return {
                success: false,
                noToken: true,
                data: []
            };
        }


        /*
         * REQUEST LẦN 1
         */
        try {
            const response =
                await requestHealthHistory(
                    trackingType
                );

            return {
                success: true,
                noToken: false,
                data:
                    response?.data?.data || []
            };

        } catch (firstError) {

            /*
             * Nếu request đầu tiên lỗi,
             * chờ một chút rồi thử lại 1 lần.
             */
            console.warn(
                "Health history request lần 1 lỗi, đang thử lại...",
                firstError
            );

            await new Promise((resolve) =>
                setTimeout(resolve, 350)
            );


            /*
             * REQUEST LẦN 2
             */
            const response =
                await requestHealthHistory(
                    trackingType
                );

            return {
                success: true,
                noToken: false,
                data:
                    response?.data?.data || []
            };
        }

    } catch (error) {
        console.error(
            "Get health history error:",
            error
        );

        return {
            success: false,
            noToken: false,
            data: [],
            error
        };
    }
};


/*
 * LẤY TẤT CẢ DỮ LIỆU SỨC KHỎE
 */
export const getAllHealthHistory =
    async () => {

        try {
            const token =
                await waitForHealthToken();

            if (!token) {
                return {
                    success: false,
                    noToken: true,
                    data: []
                };
            }

            const config = getAuthConfig();

            const response =
                await axiosInstance.get(
                    "/health-tracking/getAll",
                    {
                        ...config,

                        params: {
                            _t: Date.now()
                        }
                    }
                );

            return {
                success: true,
                noToken: false,
                data:
                    response?.data?.data || []
            };

        } catch (error) {
            console.error(
                "Get all health history error:",
                error
            );

            return {
                success: false,
                noToken: false,
                data: [],
                error
            };
        }
    };


/*
 * LƯU DỮ LIỆU
 */
export const saveHealthData = async (
    trackingType,
    trackingData
) => {
    try {
        const token =
            await waitForHealthToken();

        if (!token) {
            return {
                success: false,
                noToken: true
            };
        }

        const config = getAuthConfig();

        const response =
            await axiosInstance.post(
                "/health-tracking/create",
                {
                    tracking_type:
                        trackingType,

                    tracking_data:
                        trackingData
                },
                config
            );

        return {
            success:
                response?.data?.status === 1,

            noToken: false,

            data:
                response?.data
        };

    } catch (error) {
        console.error(
            "Save health data error:",
            error
        );

        return {
            success: false,
            noToken: false,
            error
        };
    }
};


/*
 * XÓA DỮ LIỆU
 */
export const deleteHealthData = async (
    healthTrackingId
) => {
    try {
        const token =
            await waitForHealthToken();

        if (!token) {
            return {
                success: false,
                noToken: true
            };
        }

        const config = getAuthConfig();

        const response =
            await axiosInstance.delete(
                `/health-tracking/delete/${healthTrackingId}`,
                config
            );

        return {
            success:
                response?.data?.status === 1,

            noToken: false,

            data:
                response?.data
        };

    } catch (error) {
        console.error(
            "Delete health data error:",
            error
        );

        return {
            success: false,
            noToken: false,
            error
        };
    }
};